function extractPathname(target: string | URL): string {
  if (target instanceof URL) {
    return target.pathname;
  }

  try {
    return new URL(target, "http://localhost").pathname;
  } catch {
    return target;
  }
}

export function isSamePath(target: string | URL, current: string): boolean {
  return extractPathname(target) === current;
}
